import React from "react";
import {
    Button,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Stack,
    Tooltip,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "store";
import { push } from "redux-first-history";
import { Routes } from "#/config";
import {
    selectFavoritedTableResults,
    selectFavoritedTableResultsView,
} from "#selectors";
import {
    setInterpretationFav,
    toggleInterpretationFav,
} from "#store/ui/uiActions";
import {
    FavoriteAddIcon,
    FavoriteRemoveIcon,
    FavoritesCollectionIcon,
} from "#components/icons/favorites";

export const DataCartListingSimple: React.FC = () => {
    const dispatch = useAppDispatch();
    const tableResults = useAppSelector(selectFavoritedTableResultsView);

    const handleFavChange = (id: number) => {
        dispatch(toggleInterpretationFav(id));
    };

    return (
        <>
            <Stack>
                <List dense>
                    {tableResults.map(i => {
                        return (
                            <ListItem
                                key={i.id}
                                secondaryAction={
                                    <Tooltip
                                        title={
                                            i.active
                                                ? "Remove Interpretation from Library"
                                                : "Add Interpretation to Library"
                                        }
                                    >
                                        <IconButton
                                            edge="end"
                                            aria-label="Toggle favorite"
                                            onClick={() =>
                                                handleFavChange(i.id)
                                            }
                                        >
                                            {i.active ? (
                                                <FavoriteRemoveIcon />
                                            ) : (
                                                <FavoriteAddIcon />
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                }
                            >
                                <ListItemText
                                    primary={i.table.caption}
                                    secondary={i.id}
                                />
                            </ListItem>
                        );
                    })}
                </List>

                <Button
                    variant={"outlined"}
                    onClick={() => dispatch(push(Routes.dataLibrary.path))}
                    startIcon={<FavoritesCollectionIcon />}
                    disabled={tableResults.filter(x => x.active).length < 2}
                >
                    Go to data library and compare{" "}
                    {tableResults.filter(x => x.active).length} interpretations
                </Button>
            </Stack>
        </>
    );
};
